(function () {
    'use strict';

    angular
        .module('app')
        .controller('SetSMSTemplateDialogCtrl', SetSMSTemplateDialogCtrl);

    SetSMSTemplateDialogCtrl.$inject = [
        'DialogInstance',
        'DialogService',
        'DocumentTemplatesService',
        'sms',
        'smsTemplates'];

    /**
     * @ngdoc Controller
     * @name SetSMSTemplateDialogCtrl
     *
     * @description
     * Dialog for showing a list of SMS templates which will retrieve the document template data for the selected SMS template and then append these to the SMS.
     *
     * @param {object} sms
     * @param {object} smsTemplates - SMS templates applicable to the SMS.
     */
    function SetSMSTemplateDialogCtrl(
        DialogInstance,
        DialogService,
        DocumentTemplatesService,
        sms,
        smsTemplates) {
        /* jshint validthis:true */
        var vm = this;
        vm.processing = false;
        vm.smsTemplates = angular.copy(smsTemplates);
        vm.hasValueIcon = hasValueIcon;
        vm.unselectSMSTemplates = unselectSMSTemplates;
        vm.convertContactArrayToString = convertContactArrayToString;
        vm.showDocumentTemplateFile = showDocumentTemplateFile;
        vm.cancel = cancel;
        vm.ok = ok;
        Object.defineProperty(vm, 'smsTemplateSelected', {
            get: function () { return _.some(vm.smsTemplates, function (et) { return et.Selected; }); }
        });

        /*
         * Icon to show if the supplied value is null or has an actual value
         *
         * @param {string} value - Returns an icon depending on wether the supplied value has an actual value (e.g. not null, undefined, empty string).
         *
         * @returns {string} Icon that is to be shown for the values state.
         */
        function hasValueIcon(value) {
            var result = 'unchecked';

            if (!_.isNil(value) && value !== '' && !(angular.isArray(value) && value.length === 0)) {
                result = 'checked';
            }

            return result;
        }

        /*
         * Method called when the checkbox is used for selecting or unselecting an SMS template. To ensure only one SMS template can be selected at once, this method
         * deselects all SMS templates which did not cause the method to be invoked.
         *
         * @param {object} smsTemplate - The SMS template which was changed.
         */
        function unselectSMSTemplates(smsTemplate) {
            // Unselected all SMS templates which are not the SMS template which caused this method to be trigged.
            angular.forEach(vm.smsTemplates, function (st) {
                if (smsTemplate !== st) {
                    st.Selected = false;
                }
            });

            // If the selected SMS template has changed, the error message is no longer valid.
            delete vm.error;
        }

        /*
         * Convert an array of Contact to a user readable string
         *
         * @param {array} contactArray - Array of Contact objects
         *
         * @returns {string} - Returns the Contacts in a single user readable string
         */
        function convertContactArrayToString(contactArray) {
            var result = '';

            _.forEach(contactArray, function (contact) {
                if (result !== '') {
                    result += ', ';
                }

                var addressValue = (!contact.ReferenceContact && !_.isNil(contact.Value) && contact.Value !== '') ? contact.Value : '';
                if (!_.isNil(contact.Name) && contact.Name !== '') {
                    result += contact.Name + (addressValue !== '' ? (' <' + addressValue + '>') : '');
                } else {
                    result += addressValue;
                }
            });

            return result;
        }

        /*
         * Show the document template file contents in a dialog
         *
         * @param {int} documentTemplateId - Id of the document template which has the file to be shown
         * @param {string} format - Format of the document template file which is to be shown. ('txt' or 'html')
         */
        function showDocumentTemplateFile(documentTemplateId, format) {
            DocumentTemplatesService.getDocumentFile(documentTemplateId)
                .then(getfileOk, getFileError);

            function getfileOk(response) {
                DialogService.show({
                    locals: { fileData: response.data, format: format },
                    controller: 'ViewFileContentsDialog',
                    controllerAs: 'vm',
                    templateUrl: 'app/controls/dialog/view-file-contents-dialog.tmpl.html'
                });
            }

            function getFileError(response) {
                DialogService.error('Error retrieving Document Template file', response);
            }
        }

        /*
         * Populates the SMS using the seleted SMS template. If successful the dialog will be closed, otherwise an error will be shown.
         */
        function ok() {
            vm.processing = true;
            delete vm.error;

            var selectedSMSTemplate = _.find(vm.smsTemplates, function (smsTemplate) {
                return smsTemplate.Selected;
            });

            if (!_.isNil(selectedSMSTemplate)) {
                sms.setSMSTemplate(selectedSMSTemplate)
                    .then(loadSMSTemplateOk, loadSMSTemplateError);
            } else {
                DialogInstance.ok();
            }

            function loadSMSTemplateOk() {
                DialogInstance.ok();
            }

            function loadSMSTemplateError(response) {
                vm.processing = false;
                vm.error = 'The SMS template was not successfully loaded. To retry press the "Load" button.';
            }
        }

        /*
         * Closes dialog with a cancelled state.
         */
        function cancel() {
            DialogInstance.cancel();
        }
    }
})();
